import { Component, HostListener, Input } from '@angular/core';

import { ThuisartsArticle, ThuisartsArticleContentItem, ThuisartsArticleTextItem, ThuisartsArticleVideoEntry } from '../../shared/models';
import { LinkClickTrackingService } from '../../shared/services/link-click-tracking.service';
import { LinkConfirmationService } from '../../shared/services/link-confirmation.service';

@Component({
  selector: 'thuisarts-article',
  templateUrl: './thuisarts-article.component.html',
  styleUrls: ['./thuisarts-article.component.scss'],
  standalone: false,
})
export class ThuisartsArticleComponent {
  @Input() article!: ThuisartsArticle;
  @Input() conversationId: string | null = null;

  isExpanded = false;
  private hasTrackedExpand = false;

  constructor(
    private linkClickTrackingService: LinkClickTrackingService,
    private linkConfirmationService: LinkConfirmationService,
  ) {}

  get firstItem(): ThuisartsArticleContentItem {
    return this.article.content[0];
  }

  get remainingItems(): ThuisartsArticleContentItem[] {
    return this.article.content.slice(1);
  }

  get hasMoreItems(): boolean {
    return this.article.content.length > 1;
  }

  get formattedRevisionDate(): string {
    const raw = this.article.situation?.revision_date;
    if (!raw) return '';
    return new Date(raw).toLocaleDateString('nl-NL', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }

  @HostListener('click', ['$event'])
  @HostListener('auxclick', ['$event'])
  onLinkClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a');

    if (anchor && anchor.href && this.conversationId) {
      event.preventDefault();
      this.linkConfirmationService.openLink(anchor.href, this.conversationId);
    }
  }

  isTextItem(contentItem: ThuisartsArticleContentItem): boolean {
    return contentItem.type === 'text';
  }

  asTextItem(contentItem: ThuisartsArticleContentItem): ThuisartsArticleTextItem {
    return contentItem.item as ThuisartsArticleTextItem;
  }

  asVideoEntry(contentItem: ThuisartsArticleContentItem): ThuisartsArticleVideoEntry | null {
    const entries = contentItem.item as ThuisartsArticleVideoEntry[];
    return entries.length > 0 ? entries[0] : null;
  }

  toggle(): void {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded && !this.hasTrackedExpand && this.conversationId) {
      this.hasTrackedExpand = true;
      const url = `${window.location.href}#${this.article.subject.link}`;
      this.linkClickTrackingService.trackLinkClick(this.conversationId, url);
    }
  }
}
